import { NavatticService } from './Navattic.service'

const navatticService = new NavatticService()

export { navatticService, NavatticService }
export { NavatticServiceError } from './errors'
export type * from './types'
